import React from 'react';
import './MenuItem.css';

export default function MenuItem ({ imageSrc, title, description, price, isPopular, isHearty, isComfy }) {
  return (
    <div className="container">
      <div className="item-image-container">
        <img className="item-image" src={imageSrc} alt={title} />
      </div>
      <div className="item-tags top-left">
        {isPopular && <button className="item-popular item-tag hearty">Popular</button>}
        {isHearty && <button className="item-popular item-tag hearty">Hearty</button>}
        {isComfy && <button className="item-popular item-tag comfyy">Comfy</button>}
      </div>
      <div className="item-details">
        <h3 className="item-title">{title}</h3>
        <div>{description}</div>
        <div className="item-price">${price}</div>
      </div>
    </div>
  );
}


  export const foodStock = [
    {
      imageSrc: "https://images.fineartamerica.com/images/artworkimages/mediumlarge/2/sandwich-and-fries-foodad--multi-bits.jpg",
      title: "Chickenbake and American Fries",
      description: "Dripped with relish and mayo-sweet deluxe sauce. Work on the alcohol-fuelled engine.",
      price: "35.99",
      isPopular: true
    },
    {
      imageSrc: "https://images.fineartamerica.com/images/artworkimages/mediumlarge/2/sandwich-and-fries-foodad--multi-bits.jpg",
      title: "American Fries",
      description: "Dripped with relish and mayo-sweet deluxe sauce. Work on the alcohol-fuelled engine.",
      price: "35.99",
      isPopular: true
    },
    {
      imageSrc: "https://images.fineartamerica.com/images/artworkimages/mediumlarge/2/sandwich-and-fries-foodad--multi-bits.jpg",
      title: "Chickenbake and American Fries",
      description: "Dripped with relish and mayo-sweet deluxe sauce. Work on the alcohol-fuelled engine.",
      price: "35.99",
      isPopular: true
    }
    ]